import React, { useCallback, useEffect } from 'react';

import { ReactComponent as DocumentacaoIcon } from '@/assets/icons/referral.svg';
import ButtonSmall from '@/components/ButtonSmall';

import { EmbedContainer, EmbedHeader, EmbedIframe } from './styles';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  redirect_uri: string;
  documentacao_url?: string | null;
};

const ExecucaoProtocoloEmbed: React.FC<Props> = ({
  isOpen,
  onClose,
  redirect_uri,
  documentacao_url,
}) => {
  const handleViewDocumentacao = useCallback(() => {
    if (documentacao_url) {
      window.open(documentacao_url, '_blank');
    }
  }, [documentacao_url]);

  useEffect(() => {
    const listener = (event: MessageEvent) => {
      const {
        data: { type },
      } = event;
      if (type === 'closeMedflowApp') {
        onClose();
      }
    };

    if (redirect_uri) {
      window.addEventListener('message', listener, false);
    }

    return () => window.removeEventListener('message', listener);
  }, [onClose, redirect_uri]);

  // Aplica class noscroll no HTML para desabilitar o scroll de página enquanto
  // o embed estiver aberto: ele se ajusta à viewport e quem rola é o iframe,
  // então a barra de fora só ocuparia espaço sem ter para onde rolar
  useEffect(() => {
    const html = document.getElementsByTagName('html')[0];

    if (isOpen) {
      html.classList.add('noscroll');
    } else {
      html.classList.remove('noscroll');
    }

    return () => {
      html.classList.remove('noscroll');
    };
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }

  // O iframe ocupa uma altura fixa derivada da viewport e rola internamente.
  //
  // Não dá pra dimensioná-lo pelo conteúdo: a SPA de dentro calcula um
  // `margin-bottom` a partir do próprio `window.innerHeight` (ver
  // AutoScrollList) p/ manter o passo corrente no topo. Se a altura do iframe
  // vier do conteúdo, ela vira entrada do cálculo que a produziu -- o
  // margin-bottom cresce a cada medição e a página ganha espaço vazio sem
  // parar.
  return (
    <EmbedContainer>
      <EmbedHeader>
        {documentacao_url && (
          <ButtonSmall
            onClick={handleViewDocumentacao}
            style={{
              padding: '8px 24px',
              border: '1px solid #D9DBE3',
              backgroundColor: '#FFFFFF',
              color: '#1A1A1A',
              fontSize: '14px',
              fontWeight: 700,
              lineHeight: '20px',
              borderRadius: '32px',
              gap: '8px',
            }}
          >
            <DocumentacaoIcon />
            Ver documentação
          </ButtonSmall>
        )}
      </EmbedHeader>
      <EmbedIframe
        src={redirect_uri}
        title="Execução de Protocolo"
        allow="clipboard-read; clipboard-write"
      />
    </EmbedContainer>
  );
};

export default ExecucaoProtocoloEmbed;
